import Banner from "./banner/Banner";
import CDVForm from "./cdvForm/CDVForm";
import Results from "./results/Results";
import { useState } from "react";
import { Container, Message } from "semantic-ui-react";
import useCdvActions from "../actions/cdvActions";
import TablePlaceHolder from "./shared/tablePlaceholder/TablePlaceholder";
import Footer from "./footer/Footer";

const CDV = () => {
  const [docId, setDocId] = useState("");
  const [docIdRes, setDocIdRes] = useState("");
  const cdvActions = useCdvActions();
  const [titles, setTitles] = useState([]);
  const [court, setCourt] = useState({ courtName: "", clerkName: "" });
  const [sysType, setSysType] = useState("");
  const [loading, setLoading] = useState(false);
  const [warnMessage, setWarnMessage] = useState("");

  const handleSubmit = () => {
    setLoading(true);
    setTitles([]);
    setWarnMessage("");
    //Validate document id
    if (/^(\d{3}-\d{1,7})$/.test(docId)) {
      //do the search
      cdvActions
        .search(docId)
        .then((res) => {

          if (res.status === 200) {
            let { documentDetailsModel, clerkName, courtName, systemType } = res.data;
            if (!courtName.includes("Circuit Court")) {
              courtName = courtName.replace("County", "Circuit Court");
            }
            setTitles(documentDetailsModel);
            setCourt({ clerkName, courtName });
            setSysType(systemType);
            setDocIdRes(docId);
            setLoading(false);
          }
        })
        .catch((err) => {

          setLoading(false);
          if (err.response) {
            console.log(err.response.data);
            setWarnMessage(err.response.data);
          } else {
            setWarnMessage(
              "An error occurred with searching for Document ID: " + docId
            );
          }
        });
    } else {
      setLoading(false);
      setWarnMessage(`"${docId}" is not a valid Document ID.`);
    }
  };

  return (
    <div id="page-con">
      <Banner />
      <main>
        <Container id="cdv-con">
          <h1 id="cdv-title" className="text-center">
            Certified Document ID Number Verification Portal
          </h1>

          <p id="cdv-notice">
            <b>Notice: </b>
            Virginia law does not allow the actual certified document to appear on a public website. This portal provides verification of a certified document by identification (ID) number that is placed on the document, as well as information about the document to which the number was assigned. The system cannot confirm that a particular document or its contents are identical to the document of record. You may
            <a className="underlineHover" target="_blank" rel="noreferrer" href="https://www.vacourts.gov/courts/circuit.html"> contact</a> the office of the circuit court clerk that certified the document if you have questions or concerns regarding the authenticity or contents of the document beyond what is available on this page.
          </p>

          <CDVForm
            docId={docId}
            setDocId={setDocId}
            handleSubmit={handleSubmit}
          />
          <div className="margin-top-10">
            {
              warnMessage !== "" && !loading ?
                <Message className="width-55 text-center" warning>
                  <p>{warnMessage}</p>
                </Message> : null
            }

            {loading ? (
              <TablePlaceHolder />
            ) : (
              <Results court={court} titles={titles} docId={docIdRes} sysType={sysType} />
            )}
          </div>
        </Container>
      </main>
      <div id='footer-spacer'></div>
      <Footer />
    </div>
  );
};

export default CDV;
